import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.scss';

const Loader = ({ text }) => (
    <div className={styles.loader}>
        <div className={styles.loader__spinner} />
        <div className={styles.loader__text}>{text}</div>
    </div>
);

Loader.propTypes = {
    text: PropTypes.string.isRequired,
};

export default Loader;
